import { useEffect } from "react";

import styles from "./initialSettingsTeen.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import { useTranslation } from "react-i18next";
import { useLanguage } from '../../functions/setGetLanguage';
import { useNavigate } from "react-router-dom";
import { useUserData } from "../../functions/updateUserData";

import BoxSettings from "../../components/boxSettings/boxSettings";

const InitialSettingsTeen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userData } = useUserData();

  

  const settings_options = t("settings.settings", { returnObjects: true });

  const { setLanguage } = useLanguage();
  const { i18n } = useTranslation();

  // const { settings, setSettings } = useSettings();

  useEffect(() => {
    const currentLang = i18n.language || "en";
    localStorage.setItem("i18nextLng", currentLang);
    setLanguage(`_${currentLang}`);
  }, [i18n.language, setLanguage]);

  // const handleSettingsChange = (setting, value) => {
  //   setSettings(p => ({
  //     ...p,
  //     [setting]: value,  // use brackets to use variable as key
  //   }));
  // };

  const handleCompletion = () => {
    if (userData.userTraceID){
      if (userData.userTraceID === -2){
        navigate("/social/truth-seeker");
      }
      else{
        navigate("/social/chaos");
      }
    }
    else{
      console.error("error occured, this should never be a case");
      navigate("/social");
    }
  };


  return (
    <div className={styles.wrapperLogin}>
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>
        <p className={styles.pageName}>{t("settings.page_h1")}</p>

        <BoxSettings 
          call= {t("settings.language_call")}
          subcall={t("settings.language_subcall")}
          languageBox={true}
          confirm={t("settings.confirm")}
          hdelay={"400ms"}
        />

        <BoxSettings 
          call={t("settings.box_call")}
          subcall={t("settings.box_subcall")}
          confirm={t("settings.confirm")}
          handleCompletion={handleCompletion}
          hdelay={"800ms"}
          settingsOptions={settings_options}
        />

    </div>
  );
};

export default InitialSettingsTeen;
